<template>
    <div class="cachingImageIndicatorDiv">
        <div class="cacheLoading">
            <span class="letter1">
                L
            </span>
            <span class="letter2">
                o
            </span>
            <span class="letter3">
                a
            </span>
            <span class="letter4">
                d
            </span>
            <span class="letter5">
                i
            </span>
            <span class="letter6">
                n
            </span>
            <span class="letter7">
                g
            </span>
        </div>
    </div>
</template>

<style scoped>
    .cachingImageIndicatorDiv {
        position: absolute;
        left: 0px; 
        top: 0px;
        height: inherit;
        width: inherit;
        display: flex;
        justify-content: center;
        align-items: center;
        background: white;
    }

    .letter1 {
        animation-duration: 3s;
        animation-name: neonLightsLetter1;
        animation-iteration-count: infinite;
    }

    .letter2 {
        animation: 3s infinite neonLightsLetter2
    }
    
    .letter3 {
        animation: 3s infinite neonLightsLetter3
    }
    
    .letter4 {
        animation: 3s infinite neonLightsLetter4
    }
    
    .letter5 {
        animation: 3s infinite neonLightsLetter5
    }
    
    .letter6 {
        animation: 3s infinite neonLightsLetter6
    }
    
    .letter7 {
        animation: 3s infinite neonLightsLetter7
    }

    @keyframes neonLightsLetter1 {
        0% { opacity: 0; }
        6% { opacity: 0; }
        18% { opacity: 1; }
        94% { opacity: 1; }
        100% { opacity: 0; }
    }

    @keyframes neonLightsLetter2 {
        0% {
            opacity: 0;
        }

        18% {
            opacity: 0;
        }

        30% {
            opacity: 1;
        }

        94% {
            opacity: 1;
        }

        100% {
            opacity: 0;
        }
    }

    @keyframes neonLightsLetter3 {
        0% {
            opacity: 0;
        }

        30% {
            opacity: 0;
        }

        42% {
            opacity: 1;
        }

        94% {
            opacity: 1;
        }

        100% {
            opacity: 0;
        }
    }

    @keyframes neonLightsLetter4 {
        0% {
            opacity: 0;
        }

        42% {
            opacity: 0;
        }

        54% {
            opacity: 1;
        }

        94% {
            opacity: 1;
        }

        100% {
            opacity: 0;
        }
    }

    @keyframes neonLightsLetter5 {
        0% {
            opacity: 0;
        }

        54% {
            opacity: 0;
        }

        66% {
            opacity: 1;
        }

        94% {
            opacity: 1;
        }

        100% {
            opacity: 0;
        }
    }

    @keyframes neonLightsLetter6 {
        0% {
            opacity: 0;
        }

        66% {
            opacity: 0;
        }

        78% {
            opacity: 1;
        }

        94% {
            opacity: 1;
        }

        to {
            opacity: 0;
        }
    }

    @keyframes neonLightsLetter7 {
        0% {
            opacity: 0;
        }

        78% {
            opacity: 0;
        }

        90% {
            opacity: 1;
        }

        94% {
            opacity: 1;
        }

        100% {
            opacity: 0;
        }
    }
</style>
